import React from 'react';

import Sections from './Sections';

const NavItem = () => {
  return <Sections />;
};

export default NavItem;
